import angular from 'angular';

import WelcomeModalConf from './welcome.config';
import lfActionGuide from '../../directives/lf-action-guide';
import CurrentUser from '../../models/user';

export default angular.module('app.welcome', [lfActionGuide, CurrentUser])
  .constant('WelcomeModalConf', WelcomeModalConf)
  .name;



// WEBPACK FOOTER //
// ./project/modals/welcome/index.js